// Shared configuration for Dashboard Vessel Location and saved GPS tracking.
export const GOOGLE_MAPS_LOADER_OPTIONS = {
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyDgCJRdIE3hpeL8oR9IP5LQQrzn6Olb-Ow",
    preventGoogleFontsLoading: true
};
export const VESSEL_MAP_OPTIONS = { mapTypeId: 'hybrid', fullscreenControl: true, mapTypeControl: true, zoomControl: true };
export const VESSEL_MAP_CENTER = { lat: -2.5489, lng: 118.0149 };
